<template>
  <div class="wrapper">
    <div class="chart-wrp">
      <div class="chart-title">
        <h6>开票金额变动趋势</h6>
        <div class='chart-title-tab-wrap'>
          <div class="tab-btn" v-if="dataSource === 0">
            <span :class="statisticsMonthPeriod === 'threeMonth' ? 'active' : ''" @click="changeStatisticsMonth('threeMonth')">最近三月</span>
            <span :class="statisticsMonthPeriod === 'sixMonth' ? 'active' : ''" @click="changeStatisticsMonth('sixMonth')">半年内</span>
            <span :class="statisticsMonthPeriod === 'twelveMonth' ? 'active' : ''" @click="changeStatisticsMonth('twelveMonth')">一年内</span>
          </div>
          <div class="tab-btn" v-if="dataSource === 1">
            <span :class="statisticsMonthPeriod === 'threeMonth' ? 'active-in' : ''" @click="changeStatisticsMonth('threeMonth')">最近三月</span>
            <span :class="statisticsMonthPeriod === 'sixMonth' ? 'active-in' : ''" @click="changeStatisticsMonth('sixMonth')">半年内</span>
            <span :class="statisticsMonthPeriod === 'twelveMonth' ? 'active-in' : ''" @click="changeStatisticsMonth('twelveMonth')">一年内</span>
          </div>
        </div>
      </div>
      <div class="chart">
        <highcharts :options="chartOptions" :callback="myCallback"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { invoiceRequest } from '@services'
import {
  Notify
} from 'vant'
export default {
  components: {

  },
  props: {
    dataSource: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      statisticsMonthPeriod: 'threeMonth',
      chartOptions: {
        title: {
          text: ''
        },
        colors: this.dataSource === 0 ? ['#6CF', '#06C'] : ['#FB7C23', '#FBC636'],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: [
          {
            name: '开票金额',
            data: [0, 0, 0, 0, 0, 0, 0, 154175]
          }
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }
          ]
        }
      },
      monthArr: [],
      totalAmountArr: [],
      totalNumArr: []
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getStatisticsMonth()
    this.initChart()
  },
  activated () {},
  updated () {},
  methods: {
    initChart () {
    },
    changeStatisticsMonth (period) {
      this.statisticsMonthPeriod = period
      if (period === 'threeMonth') {
        this.chartOptions.xAxis.categories = this.monthArr.slice(-3)
        let series = [
          {
            name: '开票数量',
            data: this.totalNumArr.slice(-3)
          },
          {
            name: '开票金额',
            data: this.totalAmountArr.slice(-3)
          }
        ]
        this.chartOptions.series = series
      }
      if (period === 'sixMonth') {
        this.chartOptions.xAxis.categories = this.monthArr.slice(-6)
        let series = [
          {
            name: '开票数量',
            data: this.totalNumArr.slice(-6)
          },
          {
            name: '开票金额',
            data: this.totalAmountArr.slice(-6)
          }
        ]
        this.chartOptions.series = series
      }
      if (period === 'twelveMonth') {
        this.chartOptions.xAxis.categories = this.monthArr
        let series = [
          {
            name: '开票数量',
            data: this.totalNumArr
          },
          {
            name: '开票金额',
            data: this.totalAmountArr
          }
        ]
        this.chartOptions.series = series
      }
    },
    async getStatisticsMonth () {
      let params = {
        startTime: moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        dataSource: this.dataSource
      }
      const data = await invoiceRequest.statistics.getStatisticsMonth(params)
      if (data.success) {
        if (data.result) {
          let monthArr = []
          let totalAmountArr = []
          let totalNumArr = []
          data.result.forEach(v => {
            monthArr.push(v.month)
            totalAmountArr.push(v.totalAmount)
            totalNumArr.push(v.totalNum)
          })
          this.monthArr = monthArr
          this.totalAmountArr = totalAmountArr
          this.totalNumArr = totalNumArr
          this.changeStatisticsMonth('threeMonth')
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    myCallback () {
    }
  }
}
</script>
<style scoped lang='less'>
.wrapper{
  .chart-wrp{
    margin-top: 20px;
    background: #fff;
    padding: 40px 20px;
    .chart-title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      h6 {
        box-sizing: border-box;
        font-size: 34px;
      }
      .chart-title-tab-wrap {
        text-align: right;
        .tab-btn {
          color: #999999;
          font-size:20px;
          :first-child {
            border-radius:20px 0px 0px 20px;
            border-right: none;
          }
          :last-child {
            border-radius:0px 20px 20px 0px;
            border-left: none;
          }
          span {
            display: inline-block;
            text-align: center;
            width:100px;
            height:40px;
            line-height:40px;
            border: solid 1px #D4D6DC;
          }
          .active {
            border: solid 1px #2372FF;
            background-color: #fff;
            color: #000;
          }
          .active-in {
            border: solid 1px #FB7C23;
            background-color: #fff;
            color: #000;
          }
        }
      }
    }
    .chart{
      margin-top: 40px;
      /deep/.highcharts-credits{
        display: none;
      }
    }
  }
}
</style>
